<template>
	<div>
		<el-form :model="app_info" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="App名称" prop="app_name">
				<el-input  size="small" placeholder="App名称" v-model="app_info.app_name"></el-input>
			</el-form-item>
			
			<el-form-item label="服务器IP" prop="server_ip">
				<el-input  size="small" placeholder="0.0.0.0" v-model="app_info.server_ip"></el-input>
			</el-form-item>
			
			<el-form-item label="后台地址" prop="admin_url">
				<el-input  size="small" placeholder="https://www.baidu.com" v-model="app_info.admin_url"></el-input>
			</el-form-item>
			
			<el-form-item label="接口地址" prop="request_url">
				<el-input  size="small" placeholder="https://www.baidu.com (后缀没有/)" v-model="app_info.request_url"></el-input>
			</el-form-item>
			
			<el-form-item label="分享地址" prop="share_url">
				<el-input  size="small" placeholder="https://www.baidu.com (后缀没有/)" v-model="app_info.share_url"></el-input>
			</el-form-item>
			
			<el-form-item label="APK地址">
				<el-input  size="small" placeholder="https://www.baidu.com/a.apk" v-model="app_info.apk_url"></el-input>
			</el-form-item>
			
			<el-form-item label="iOS地址">
				<el-input  size="small" placeholder="https://www.baidu.com/a.plist" v-model="app_info.ios_url"></el-input>
			</el-form-item>
			
			<el-form-item label="备注信息">
				<el-input  size="small" v-model="app_info.remark"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
				<!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['app_info'],
	    data() {
	      return {
	        rules: {
			  admin_url: [{required: true, message: '此项为必填项', trigger: 'blur'}],
	          app_name: [{required: true, message: '此项为必填项', trigger: 'blur'}],
			  server_ip: [{required: true, message: '此项为必填项', trigger: 'blur'}],
			  request_url: [{required: true, message: '此项为必填项', trigger: 'blur'}],
			  share_url: [{required: true, message: '此项为必填项', trigger: 'blur'}],
	          username: [{required: true, min: 2, max: 26, message: '请输入至少2位登录名', trigger: 'blur'}],
	          password: [{required: true, min: 5, max: 26,message: '请输入至少5位密码', trigger: 'blur'}],
	          rule: [{required: true, message: '请选择角色', trigger: 'blur'}]
	        }
	      };
	    },
	    methods: {
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/App/addApp", this.app_info).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '添加成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return that.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				if(formName == ''){
					formName = 'ruleForm';
				}
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>